<script setup lang="ts">
/**
 * Query-aware empty state wrapper around UEmpty.
 *
 * Shows a context-sensitive title based on whether a search query is active.
 * When a query is present, prompts the user to refine their search.
 * When no query, indicates that no records exist yet.
 *
 * @example
 * ```vue
 * <EmptyState :icon="ICON.tag" noun="tags" :query="query" />
 * ```
 */

const props = defineProps<{
  /** The icon name to display */
  icon: string
  /** Plural noun for the resource, e.g. "tags", "people", "items" */
  noun: string
  /** Current search query — empty string means no search active */
  query: string
}>()

const title = props.query ? `No matching ${props.noun}` : `No ${props.noun} yet`
const description = props.query ? "Try a different search term" : undefined
</script>

<template>
  <UEmpty :icon="icon" :title="title" :description="description" />
</template>
